// extracted by mini-css-extract-plugin
export default {"favorite__absent":"App_favorite__absent__9DMB-"};